import React from "react";
import { createPortal } from "react-dom";
import { apiFetch } from "../lib/api";
const sequenceBoardStyles = `
.campaign-ui {
  --ui-ink: #0f1221;
  --ui-text: #111318;
  --ui-muted: #6b7280;
  --ui-border: rgba(17, 24, 39, .10);
  --ui-border-2: rgba(17, 24, 39, .16);
  --ui-soft: #f7f9fc;
  --ui-card: #ffffff;
  --ui-accent: #6E5BFF;
  --ui-accent-2: #A78BFA;
  --ui-accent-grad: linear-gradient(90deg, var(--ui-accent), var(--ui-accent-2));
}

.campaign-ui * { box-sizing: border-box; }
.campaign-ui input, .campaign-ui select, .campaign-ui textarea, .campaign-ui button { font: inherit; color: inherit; }

/* Card */
.campaign-ui .sb-card { margin-bottom: 12px; overflow: visible; }
.campaign-ui h4 { margin: 0 0 8px; color: var(--ui-ink); letter-spacing: .01em; }

/* Loading/empty/error */
.campaign-ui .sb-loading { color: var(--ui-muted); padding: 8px 2px; }
.campaign-ui .sb-loading-card { background: transparent; }
.campaign-ui .sb-empty {
  border: 1px dashed var(--ui-border);
  border-radius: 12px;
  padding: 16px;
  background: #0f172a;
  color: #cbd5e1;
}
.campaign-ui .sb-empty-inner { text-align: center; }
.campaign-ui .sb-empty h5 { margin: 4px 0 8px; font-size: 16px; letter-spacing:.01em; }
.campaign-ui .sb-dot { width: 12px; height: 12px; border-radius: 999px; margin: 0 auto 8px; background: var(--ui-accent-grad); box-shadow: 0 0 0 4px rgba(110, 91, 255, .15); }
.campaign-ui .sb-error { color: #9b1c1c; margin-top: 8px; }

/* Buttons */
.campaign-ui .psl-btn {
  border: 1px solid var(--ui-border);
  background: #fff;
  color: var(--ui-ink);
  border-radius: 12px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
  transition: transform .12s ease, background .18s ease, border-color .18s ease, box-shadow .18s ease;
}
.campaign-ui .psl-btn:hover { background:#F5F7FB; transform: translateY(-1px); }
.campaign-ui .psl-btn:disabled { opacity:.6; cursor:not-allowed; }
.campaign-ui .psl-btn.primary {
  background: var(--ui-accent-grad);
  color:#fff; border-color: transparent;
  box-shadow: 0 10px 24px rgba(110,91,255,.20);
}
.campaign-ui .psl-btn--micro { padding: 6px 8px; font-size: 12.5px; border-radius: 8px; }

/* Inputs */
.campaign-ui .psl-input,
.campaign-ui select.psl-input,
.campaign-ui textarea.psl-input {
  appearance: none;
  width: 100%;
  background: #fff;
  color: var(--ui-text);
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.25;
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease, background-color .15s ease;
}
.campaign-ui .psl-input:hover,
.campaign-ui select.psl-input:hover,
.campaign-ui textarea.psl-input:hover { border-color:#D1D5DB; }
.campaign-ui .psl-input:focus,
.campaign-ui select.psl-input:focus,
.campaign-ui textarea.psl-input:focus {
  border-color:#1F2937; box-shadow:0 0 0 3px rgba(0,0,0,.08);
}

/* Steps rail */
.campaign-ui .sb-steps {
  position: relative;
  display: grid;
  gap: 10px;
  padding-left: 10px;
}
.campaign-ui .sb-steps::before {
  content: "";
  position: absolute;
  left: 18px;
  top: 6px;
  bottom: 6px;
  width: 2px;
  background: linear-gradient(180deg, rgba(110,91,255,.18), rgba(167,139,250,.18));
  border-radius: 2px;
}

/* Row */
.campaign-ui .psl-row {
  display: grid;
  grid-template-columns: 48px 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 10px;
  background: #fff;
  border: 1px solid var(--ui-border);
  border-radius: 10px;
  transition: box-shadow .18s ease, border-color .18s ease, transform .12s ease;
  position: relative;
  overflow: visible;
}
.campaign-ui .psl-row:hover {
  box-shadow: 0 10px 24px rgba(16,24,40,.06);
  border-color: var(--ui-border-2);
}
.campaign-ui .psl-row.is-selected {
  border-color: rgba(110,91,255,.35);
  box-shadow: 0 12px 26px rgba(110,91,255,.10);
}

/* Step dot */
.campaign-ui .psl-row::before {
  content: "";
  position: absolute;
  left: -2px;
  top: 14px;
  width: 10px; height: 10px; border-radius: 999px;
  background: var(--ui-accent-grad);
  box-shadow: 0 0 0 4px rgba(110, 91, 255, .12);
}

/* Row cells */
.campaign-ui .sb-left {
  display: grid; gap: 6px; align-items: center; justify-items: center;
}
.campaign-ui .psl-row-toggle {
  width:24px; height:24px; border-radius:8px;
  border:1px solid var(--ui-border);
  background:#fff; cursor:pointer;
  transition: transform .12s ease, background .18s ease, border-color .18s ease, box-shadow .18s ease;
}
.campaign-ui .psl-row-toggle:hover { background:#F5F7FB; transform: translateY(-1px); }
.campaign-ui .sb-stepno { font-weight: 800; font-size: 12px; color: var(--ui-ink); }

.campaign-ui .sb-mid { display: grid; gap: 6px; min-width: 0; }
.campaign-ui .sb-title {
  display: flex; align-items: center; gap: 10px; flex-wrap: wrap; cursor: pointer; min-width: 0;
}

/* Inline subject behavior */
.campaign-ui .sb-subject-inline { width: min(520px, 100%); }
.campaign-ui .sb-subject-inline[readonly] {
  background: #fbfbfe;
  color: #4b5563;
  cursor: pointer;
}
.campaign-ui .sb-subject-inline:not([readonly]) {
  background: #fff;
  color: #0f1221;
  cursor: text;
}

/* Right side (timing + actions) */
.campaign-ui .sb-right { display: grid; gap: 8px; justify-items: end; position: relative; overflow: visible; }
.campaign-ui .sb-when-link {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
}

/* Popover (fixed) */
.psl-pop.sb-pop {
  min-width: 320px;
  background:#0f172a;
  color:#e5e7eb;
  border:1px solid #1f2937;
  border-radius:12px;
  padding:10px;
  box-shadow:0 20px 50px rgba(0,0,0,.38);
  z-index: 10000;
}

.psl-pop.sb-pop::before {
  display: none;
}

.psl-pop.sb-pop .psl-input {
  background: rgba(255,255,255,.06);
  color:#e7e9ee;
  border:1px solid #334155;
}

.psl-pop-row {
  display:flex;
  align-items:center;
  gap:8px;
  padding:6px 2px;
}

.psl-pop-actions {
  display:flex;
  justify-content:flex-end;
  gap:8px;
  padding-top:8px;
  border-top:1px solid #1f2937;
}

.psl-radio {
  display:flex;
  align-items:center;
  gap:8px;
  margin:4px 0;
}

/* Row actions */
.campaign-ui .sb-row-actions { display: inline-flex; gap: 6px; }

/* Inline editor container */
.campaign-ui .sb-editor {
  border-left: 3px solid rgba(110,91,255,.35);
  padding-left: 10px;
  margin-bottom: 12px;
}
.campaign-ui .sb-inline {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.campaign-ui .sb-pane {
  background:#fff; border:1px solid var(--ui-border); border-radius:12px; overflow:hidden;
}
.campaign-ui .sb-pane-head {
  display:flex; align-items:center; gap:8px; padding:10px; border-bottom:1px solid var(--ui-border);
  background: linear-gradient(180deg, #fff, #f9fafb);
}
.campaign-ui .sb-pane-actions { margin-left: auto; display: inline-flex; gap: 8px; }
.campaign-ui .sb-pane-body { padding: 10px; display: grid; gap: 8px; }

.campaign-ui .sb-editor-row2 {
  display: grid; grid-template-columns: 1fr 180px; gap: 8px;
}

/* Token bar + info */
.campaign-ui .sb-tokenbar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin: 6px 0 8px;
}
.campaign-ui .sb-dynvars {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: var(--ui-muted);
  margin-right: 6px;
}
.campaign-ui .sb-info {
  display: inline-grid;
  place-items: center;
  width: 18px; height: 18px;
  border-radius: 999px;
  border: 1px solid var(--ui-border);
  background: var(--ui-soft);
  font-size: 12px; font-weight: 800;
  color: #334155;
  cursor: help;
  padding: 0;
}
.campaign-ui .sb-info:hover { background: #f1f5ff; }
.campaign-ui .psl-chip{
  border:1px solid var(--ui-border); background:#fff; color:var(--ui-ink);
  border-radius:999px; padding:4px 8px; font-size:12.5px; cursor:pointer;
  transition: transform .12s ease, background .18s ease, border-color .18s ease, box-shadow .18s ease;
}
.campaign-ui .psl-chip:hover{ background:#F5F7FB; transform:translateY(-1px); }

.campaign-ui .sb-body {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}
.campaign-ui .sb-mini-fields { display: flex; gap: 12px; flex-wrap: wrap; align-items: center; }

/* Preview (dark) */
.campaign-ui .psl-preview {
  display:grid; gap:8px;
  background:#0f172a; color:#e5e7eb;
  border-radius:10px; border:1px solid #1f2937; padding:12px;
}
.campaign-ui .psl-preview .psl-preview-head { display: grid; gap: 6px; }
.campaign-ui .psl-preview .psl-preview-head b { color:#fff; }

/* Footer actions (right-aligned) */
.campaign-ui .sb-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  justify-content: flex-end;
}

/* Sticky Save bar */
.campaign-ui .sb-sticky {
  position: sticky;
  bottom: 8px;
  opacity: 0;
  transform: translateY(6px);
  pointer-events: none;
  transition: opacity .2s ease, transform .2s ease;
}
.campaign-ui .sb-sticky.is-visible {
  opacity: 1; transform: translateY(0);
  pointer-events: auto;
}
.campaign-ui .sb-sticky-inner {
  display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap;
  background: rgba(255,255,255,.88);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--ui-border);
  border-radius: 12px;
  padding: 10px 12px;
  box-shadow: 0 12px 28px rgba(16,24,40,.12);
}
.campaign-ui .sb-sticky-badge {
  display: inline-flex; align-items: center; gap: 8px; font-weight: 800; color: var(--ui-ink);
}
.campaign-ui .sb-sticky-dot {
  width: 10px; height: 10px; border-radius: 999px; background: var(--ui-accent-grad);
  box-shadow: 0 0 0 4px rgba(110,91,255,.15);
}
.campaign-ui .sb-sticky-actions { display: inline-flex; gap: 8px; }

/* Responsive */
@media (max-width: 980px) {
  .campaign-ui .sb-inline { grid-template-columns: 1fr; }
  .campaign-ui .sb-editor-row2 { grid-template-columns: 1fr; }
}
@media (max-width: 720px) {
  .campaign-ui .psl-row { grid-template-columns: 44px 1fr; }
  .campaign-ui .sb-right { justify-items: start; }
}

/* Help popover used for tokens/timing help */
.campaign-ui .sb-help-pop {
  margin-top: 8px;
  border: 1px solid #1f2937;
  background: #0b1224;
  color: #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  line-height: 1.45;
}
.campaign-ui .sb-help-pop ul { margin: 6px 0 0 18px; }
.campaign-ui .sb-help-pop code { background: rgba(255,255,255,.06); padding: 1px 6px; border-radius: 6px; }

/* Auto-stop badge */
.campaign-ui .sb-header { display:flex; align-items:center; justify-content: space-between; }
.campaign-ui .sb-autostop {
  font-size: 12.5px;
  color: #334155;
  border: 1px dashed #cbd5e1;
  border-radius: 999px;
  padding: 4px 8px;
  background: #f8fafc;
}

/* Make the inline editor stand out more */
.campaign-ui .sb-editor {
  border-left: 3px solid rgba(110,91,255,.55);
  background: #fbfbff;
  padding-left: 10px;
  margin-bottom: 12px;
}

/* Make the blue 'Timing' link look clearer */
.campaign-ui .sb-when-link {
  color: #1d4ed8;
  text-decoration: underline;
}

/* Plane icon color in headers */
.psl-plane { color: #6E5BFF; }
.campaign-ui .psl-row.is-selected {
  background: #fbfbfe;
  border-color: rgba(110,91,255,.55);
  box-shadow: 0 12px 26px rgba(110,91,255,.12);
}
`;

const SequenceBoard = React.forwardRef(function SequenceBoard({ campaignId, templates = [], apiGetSteps, apiSaveSteps, onDirtyChange = () => { }, onSequenceSaved = () => { } }, ref) {  // ---------- state ----------
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [err, setErr] = React.useState("");

  const [openStep, setOpenStep] = React.useState(null);

  const [recips, setRecips] = React.useState([]);
  const [recipsLoaded, setRecipsLoaded] = React.useState(false);

  // { [step_no]: {templateId, subject, bodyText, offset_days, delay_minutes, send_hour_utc, saving} }
  // (thread_with_first is enforced by UI logic: step 1 = false, step >1 = true)
  const [edits, setEdits] = React.useState({});

  // sticky save signature
  const [savedSig, setSavedSig] = React.useState("");
  const savedRowsRef = React.useRef([]);
  const [dirty, setDirty] = React.useState(false);
  const [draftDirty, setDraftDirty] = React.useState(false);

  // template index
  const tIndex = React.useMemo(() => {
    const m = new Map();
    for (const t of templates) m.set(Number(t.id), t);
    return m;
  }, [templates]);

  // tokens + refs (removed {{email}})
  const TOKENS = ["{{curator_name}}", "{{playlist_name}}", "{{playlist_url}}", "{{sender_name}}"];
  const subjectRef = React.useRef(null);
  const bodyRef = React.useRef(null);

  // schedule popover
  const [openSchedFor, setOpenSchedFor] = React.useState(null); // step_no
  const [schedAnchor, setSchedAnchor] = React.useState(null);   // {left, top} (fixed)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const schedRef = React.useRef(null);

  // help popovers
  const [showVarsHelp, setShowVarsHelp] = React.useState(false);
  const [showTimingHelp, setShowTimingHelp] = React.useState(false);

  // mode: "immediate" | "after" | "hour"
  const [schedDraft, setSchedDraft] = React.useState({ mode: "immediate", qty: 30, unit: "minutes", hour: 9 });

  // ---------- effects ----------
  React.useEffect(() => {
    if (!campaignId || !apiGetSteps) return;
    let ignore = false;
    (async () => {
      setLoading(true);
      setErr("");
      try {
        const res = await apiGetSteps(campaignId);
        const arr =
          Array.isArray(res) ? res :
            Array.isArray(res?.items) ? res.items :
              Array.isArray(res?.data) ? res.data :
                Array.isArray(res?.result) ? res.result :
                  [];

        const norm = arr
          .map((i) => {
            const tpl = tIndex.get(Number(i.template_id));
            return {
              step_no: Number(i.step_no),
              template_id: i.template_id ?? null,
              subject: (i.subject ?? "").trim() || tpl?.subject || "",
              // Backend expects per-step *relative* offsets for step>1
              offset_days: Number(i.offset_days ?? (i.step_no === 1 ? 0 : 2)),
              delay_minutes: Number(i.delay_minutes ?? 0),
              send_hour_utc: i.send_hour_utc == null ? null : Number(i.send_hour_utc),
              // thread_with_first is enforced by UI below
              enabled: i.enabled !== false,
              type: i.type || "email",
            };
          })
          .sort((a, b) => a.step_no - b.step_no);

        if (!ignore) {
          setRows(norm);
          const sig = signatureFor(norm);
          setSavedSig(sig);
          savedRowsRef.current = deepCopy(norm);
          setDirty(false);
        }
      } catch (e) {
        if (!ignore) setErr(e?.message || "Failed to load steps");
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [campaignId, apiGetSteps, tIndex]);

  React.useEffect(() => {
    const sig = signatureFor(rows);
    const d = (sig !== savedSig) || draftDirty;
    setDirty(d);
    onDirtyChange(d);
  }, [rows, savedSig, draftDirty, onDirtyChange]);

  // save shortcut
  React.useEffect(() => {
    const onKey = (e) => {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      const mod = isMac ? e.metaKey : e.ctrlKey;
      if (mod && e.key.toLowerCase() === "s") {
        e.preventDefault();
        if (dirty) saveSequence();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [dirty, rows]);

  React.useLayoutEffect(() => {
    if (!openSchedFor) return;

    const onEsc = (e) => {
      if (e.key === "Escape") setOpenSchedFor(null);
    };
    const onScrollOrResize = () => repositionPopover();

    document.addEventListener("keydown", onEsc);
    window.addEventListener("scroll", onScrollOrResize, true);
    window.addEventListener("resize", onScrollOrResize);

    repositionPopover();

    return () => {
      document.removeEventListener("keydown", onEsc);
      window.removeEventListener("scroll", onScrollOrResize, true);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [openSchedFor, anchorEl]);

  // ---------- APIs ----------
  async function ensureRecipients() {
    if (recipsLoaded) return;
    try {
      const r = await apiFetch(`/api/email/campaigns/${campaignId}/recipients?limit=50`, { credentials: "include" });
      setRecips(Array.isArray(r.items) ? r.items : []);
      setRecipsLoaded(true);
    } catch { }
  }
  async function apiGetTemplate(id) {
    const j = await apiFetch(`/api/email/templates/${id}`, { credentials: "include" });
    return j?.item;
  }
  async function apiUpdateTemplate(id, data) {
    const j = await apiFetch(`/api/email/templates/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      credentials: "include",
    });
    return j?.item;
  }

  // ---------- helpers ----------


  async function loadAndSyncSteps() {
    // 1) fetch from server
    const res = await apiGetSteps(campaignId);
    const items =
      Array.isArray(res) ? res :
        Array.isArray(res?.items) ? res.items :
          Array.isArray(res?.data) ? res.data :
            Array.isArray(res?.result) ? res.result :
              [];

    // 2) normalize (same logic you used in the initial load)
    const norm = items
      .map((i) => {
        const tpl = tIndex.get(Number(i.template_id));
        return {
          step_no: Number(i.step_no),
          template_id: i.template_id != null ? Number(i.template_id) : null,
          subject: (i.subject ?? "").trim() || tpl?.subject || "",
          offset_days: Number(i.offset_days ?? (i.step_no === 1 ? 0 : 2)),
          delay_minutes: Number(i.delay_minutes ?? 0),
          send_hour_utc: i.send_hour_utc == null ? null : Number(i.send_hour_utc),
          enabled: i.enabled !== false,
          type: i.type || "email",
        };
      })
      .sort((a, b) => a.step_no - b.step_no);

    // 3) sync UI state to DB truth
    setRows(norm);
    setSavedSig(signatureFor(norm));
    savedRowsRef.current = JSON.parse(JSON.stringify(norm));
    setDraftDirty(false);

    // 4) keep inline editor pointing at the *current* template ids
    const idByStep = new Map(items.map(s => [Number(s.step_no), Number(s.template_id)]));
    setEdits((prev) => {
      const next = {};
      for (const [k, v] of Object.entries(prev)) {
        const sn = Number(k);
        if (norm.find(r => r.step_no === sn)) {
          next[k] = { ...v, templateId: idByStep.get(sn) ?? v.templateId };
        }
      }
      return next;
    });
  }

  const deepCopy = (v) => JSON.parse(JSON.stringify(v));

  const cumulativeDaysUpTo = (idx) => {
    let sum = 0;
    for (let i = 0; i <= idx; i++) sum += Math.max(0, Number(rows[i]?.offset_days || 0));
    return sum;
  };

  const titleFor = (idx, r) => {
    const day = cumulativeDaysUpTo(idx) + 1;
    const typeLabel = r.type === "call" ? "Phone call" : r.type === "linkedin" ? "LinkedIn message" : "Email";
    return `Day ${day} • ${typeLabel}`;
  };

  const humanize = (d, m) => {
    d = Math.max(0, Number(d || 0));
    m = Math.max(0, Number(m || 0));
    if (d === 0 && m === 0) return "immediately";
    const parts = [];
    if (d >= 7 && d % 7 === 0) parts.push(`${d / 7} week${d === 7 ? "" : "s"}`);
    else if (d > 0) parts.push(`${d} day${d === 1 ? "" : "s"}`);
    if (m > 0) parts.push(`${m} minute${m === 1 ? "" : "s"}`);
    return `after ${parts.join(" ")}`;
  };

  const sendLabel = (idx) => {
    const r = rows[idx];
    if (idx === 0) {
      if (r.send_hour_utc != null) return `Send at ${String(r.send_hour_utc).padStart(2, "0")}:00 (Step 1)`;
      return `Send ${humanize(r.offset_days, r.delay_minutes)} (Step 1)`;
    }
    if ((r.offset_days || 0) === 0 && (r.delay_minutes || 0) === 0) return "Send immediately after previous";
    return `Send ${humanize(r.offset_days, r.delay_minutes)}`;
  };

  const htmlToText = (html) =>
    String(html || "")
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/<\/(p|div|br|li)>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim();

  const textToHtml = (text) => {
    const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const blocks = String(text || "").replace(/\r\n/g, "\n").split(/\n{2,}/);
    return blocks.map((b) => `<p>${esc(b).replace(/\n/g, "<br/>")}</p>`).join("\n");
  };

  const cleanedForPersist = (list) =>
    list
      .filter((r) => r.enabled)
      .map((r, i) => ({
        step_no: Math.max(1, Number(r.step_no || i + 1)),
        type: r.type,
        template_id: Number(r.template_id || 0) || null,
        offset_days: Math.max(0, Number(r.offset_days || 0)),
        delay_minutes: Math.max(0, Number(r.delay_minutes || 0)) || 0,
        send_hour_utc: r.send_hour_utc == null || r.send_hour_utc === "" ? null : Math.min(23, Math.max(0, Number(r.send_hour_utc))),
        // enforce reply-to-first threading model:
        thread_with_first: r.step_no > 1,
      }));

  const signatureFor = (list) => JSON.stringify(cleanedForPersist(list));

  const toDaysMinutes = (qty, unit) => {
    let days = 0;
    let minutes = 0;
    const q = Math.max(0, Number(qty || 0));
    switch (String(unit)) {
      case "weeks": days = q * 7; break;
      case "days": days = q; break;
      case "seconds": minutes = Math.max(1, Math.ceil(q / 60)); break;
      default: minutes = q; // minutes
    }
    if (minutes >= 1440) {
      const extraDays = Math.floor(minutes / 1440);
      days += extraDays;
      minutes = minutes % 1440;
    }
    return { days, minutes };
  };

  // ---------- handlers ----------
  async function toggleOpen(step) {
    if (openStep === step) { setOpenStep(null); return; }
    setOpenStep(step);
    await ensureRecipients();
    if (!edits[step]) {
      const row = rows.find((r) => r.step_no === step);
      if (!row) return;
      let tpl = tIndex.get(Number(row.template_id));
      if (!tpl) tpl = await apiGetTemplate(row.template_id);
      const bodyText = tpl?.text != null && tpl.text !== "" ? tpl.text : htmlToText(tpl?.html || "");
      setEdits((m) => ({
        ...m,
        [step]: {
          templateId: row.template_id,
          subject: tpl?.subject || row.subject || "",
          bodyText,
          offset_days: row.offset_days ?? 0,
          delay_minutes: row.delay_minutes ?? 0,
          send_hour_utc: row.send_hour_utc ?? null,
          saving: false,
        },
      }));
    }
  }

  const insertToken = (field, token) => {
    const ref = field === "subject" ? subjectRef.current : bodyRef.current;
    if (!ref || !openStep) return;
    const start = ref.selectionStart ?? 0;
    const end = ref.selectionEnd ?? start;
    setEdits((s) => {
      const cur = s[openStep]; if (!cur) return s;
      const val = field === "subject" ? cur.subject : cur.bodyText;
      const next = String(val || "").slice(0, start) + token + String(val || "").slice(end);
      setDraftDirty(true);
      return { ...s, [openStep]: { ...cur, [field === "subject" ? "subject" : "bodyText"]: next } };
    });
    setTimeout(() => {
      try { ref.focus(); ref.setSelectionRange(start + token.length, start + token.length); } catch { }
    }, 0);
  };

  const addRow = () => {
    const nextNo = rows.length ? Math.max(...rows.map((r) => r.step_no)) + 1 : 1;
    const isFirst = nextNo === 1;
    setRows([
      ...rows,
      {
        step_no: nextNo,
        template_id: templates[0]?.id || null,
        subject: templates[0]?.subject || "",
        offset_days: isFirst ? 0 : 2,
        delay_minutes: 0,
        send_hour_utc: isFirst ? null : null,
        enabled: true,
        type: "email",
      },
    ]);
  };

  const duplicateRow = (row) => {
    const nextNo = rows.length ? Math.max(...rows.map((r) => r.step_no)) + 1 : 1;
    const copy = { ...row, step_no: nextNo };
    setRows([...rows, copy]);
  };

  const removeRow = (row) => {
    setRows((rs) => rs.filter((r) => r.step_no !== row.step_no));
    setEdits((s) => { const n = { ...s }; delete n[row.step_no]; return n; });
    if (openStep === row.step_no) setOpenStep(null);
    if (openSchedFor === row.step_no) setOpenSchedFor(null);
  };


  async function saveInline(stepNo) {
    const e = edits[stepNo];
    if (!e) return;

    if (stepNo === 1 && !String(e.subject || "").trim()) {
      alert("Subject is required for Step 1");
      return;
    }

    setEdits((s) => ({ ...s, [stepNo]: { ...s[stepNo], saving: true } }));
    try {
      const enabledSorted = rows
        .filter(r => r.enabled)
        .sort((a, b) => a.step_no - b.step_no)
        .map((r, i) => ({ ...r, step_no: i + 1 }));

      const cleanedAll = cleanedForPersist(enabledSorted);
      await apiSaveSteps(campaignId, cleanedAll);

      const fresh = await apiGetSteps(campaignId);
      const mine = (Array.isArray(fresh?.items) ? fresh.items : fresh).find(s => Number(s.step_no) === stepNo);
      const tplId = Number(mine?.template_id || e.templateId);

      const payload = {
        text: e.bodyText,
        html: textToHtml(e.bodyText),
      };
      if (stepNo === 1) payload.subject = String(e.subject || "").trim();

      await apiUpdateTemplate(tplId, payload);

      setRows((rs) => rs.map((r) =>
        r.step_no === stepNo
          ? {
            ...r,
            template_id: tplId,
            subject: e.subject,
            offset_days: e.offset_days,
            delay_minutes: e.delay_minutes,
            send_hour_utc: e.send_hour_utc,
          }
          : r
      ));
      setEdits((s) => ({ ...s, [stepNo]: { ...s[stepNo], templateId: tplId } }));

      const post = rows.map((r) =>
        r.step_no === stepNo
          ? { ...r, template_id: tplId, offset_days: e.offset_days, delay_minutes: e.delay_minutes, send_hour_utc: e.send_hour_utc }
          : r
      );
      const sig = signatureFor(post);
      setSavedSig(sig);
      savedRowsRef.current = JSON.parse(JSON.stringify(post));
      await loadAndSyncSteps();

      alert("Saved ✓");
      setDraftDirty(false);
    } catch (er) {
      alert(er?.message || "Failed to save");
    } finally {
      setEdits((s) => ({ ...s, [stepNo]: { ...s[stepNo], saving: false } }));
    }
  }


  async function saveSequence() {
    try {
      const enabledSorted = rows
        .filter(r => r.enabled)
        .sort((a, b) => a.step_no - b.step_no);

      const oldToNew = new Map(enabledSorted.map((r, i) => [r.step_no, i + 1]));

      const normalized = enabledSorted.map((r, i) => ({ ...r, step_no: i + 1 }));

      const cleaned = cleanedForPersist(normalized);
      await apiSaveSteps(campaignId, cleaned);

      const fresh = await apiGetSteps(campaignId);
      const items = Array.isArray(fresh?.items) ? fresh.items : Array.isArray(fresh) ? fresh : [];
      const idByStep = new Map(items.map(s => [Number(s.step_no), Number(s.template_id)]));

      const remappedEdits = Object.fromEntries(
        Object.entries(edits)
          .map(([oldNoStr, e]) => {
            const newNo = oldToNew.get(Number(oldNoStr));
            return newNo ? [String(newNo), e] : null;
          })
          .filter(Boolean)
      );

      const updates = [];
      for (const [stepNoStr, e] of Object.entries(remappedEdits)) {
        const stepNo = Number(stepNoStr);
        const tplId = idByStep.get(stepNo) || e.templateId;
        const payload = { text: e.bodyText, html: textToHtml(e.bodyText) };
        if (stepNo === 1) payload.subject = String(e.subject || "").trim();
        updates.push(apiUpdateTemplate(tplId, payload));
      }
      if (updates.length) await Promise.all(updates);

      const sig = JSON.stringify(cleaned);
      setSavedSig(sig);
      savedRowsRef.current = JSON.parse(JSON.stringify(normalized));
      setRows(normalized);
      setEdits(remappedEdits);
      setDirty(false);
      setDraftDirty(false);
      onDirtyChange(false);
      await loadAndSyncSteps();

      alert("Sequence saved ✓");
      onSequenceSaved();
      return true;
    } catch (e) {
      alert(e?.message || "Failed to save sequence");
      return false;
    }
  }

  React.useImperativeHandle(ref, () => ({
    saveSequence: async () => {
      const ok = await saveSequence();
      return ok;
    },
    closeAllEditors: () => {
      setOpenStep(null);
      setOpenSchedFor(null);
    },
  }));
  function discardChanges() {
    setRows(deepCopy(savedRowsRef.current || []));
    setOpenStep(null);
    setOpenSchedFor(null);
    setDraftDirty(false);
  }

  function repositionPopover() {
    if (!openSchedFor || !anchorEl || !schedRef.current) return;

    const GAP = 30;
    const rect = anchorEl.getBoundingClientRect();
    const pop = schedRef.current;
    const popW = pop.offsetWidth || 320;
    const popH = pop.offsetHeight || 260;

    let left = rect.right - popW;
    let top = rect.bottom + GAP;

    left = Math.max(8, Math.min(left, window.innerWidth - popW - 8));
    top = Math.max(8, Math.min(top, window.innerHeight - popH - 8));

    setSchedAnchor({ left, top });
  }

  const openSchedule = (row, idx, ev) => {
    setAnchorEl(ev.currentTarget);
    const hasDelay = (Number(row.delay_minutes) || 0) > 0 || (Number(row.offset_days) || 0) > 0;

    if (idx === 0) {
      if (row.send_hour_utc != null) {
        setSchedDraft({ mode: "hour", hour: Number(row.send_hour_utc) || 9, qty: 30, unit: "minutes" });
      } else if (hasDelay) {
        const unit = row.delay_minutes > 0 ? "minutes" : "days";
        const qty = unit === "minutes" ? Number(row.delay_minutes) : Number(row.offset_days);
        setSchedDraft({ mode: "after", qty, unit, hour: 9 });
      } else {
        setSchedDraft({ mode: "immediate", qty: 30, unit: "minutes", hour: 9 });
      }
    } else {
      if (hasDelay) {
        const unit = row.delay_minutes > 0 ? "minutes" : "days";
        const qty = unit === "minutes" ? Number(row.delay_minutes) : Number(row.offset_days);
        setSchedDraft({ mode: "after", qty, unit, hour: 9 });
      } else {
        setSchedDraft({ mode: "immediate", qty: 1, unit: "days", hour: 9 });
      }
    }
    setOpenSchedFor(row.step_no);
  };

  const applySchedule = (row, idx) => {
    const apply = (r) => {
      if (r.step_no !== row.step_no) return r;
      if (idx === 0) {
        if (schedDraft.mode === "hour") {
          return { ...r, send_hour_utc: Math.min(23, Math.max(0, Number(schedDraft.hour) || 0)), offset_days: r.offset_days || 0, delay_minutes: r.delay_minutes || 0 };
        }
        if (schedDraft.mode === "after") {
          const { days, minutes } = toDaysMinutes(schedDraft.qty, schedDraft.unit);
          return { ...r, send_hour_utc: null, offset_days: days, delay_minutes: minutes };
        }
        return { ...r, send_hour_utc: null, offset_days: 0, delay_minutes: 0 };
      } else {
        if (schedDraft.mode === "after") {
          const { days, minutes } = toDaysMinutes(schedDraft.qty, schedDraft.unit);
          return { ...r, offset_days: days, delay_minutes: minutes, send_hour_utc: null };
        }
        return { ...r, offset_days: 0, delay_minutes: 0, send_hour_utc: null };
      }
    };

    setRows((rs) => rs.map(apply));

    setEdits((s) => {
      const e = s[row.step_no];
      if (!e) return s;

      if (idx === 0) {
        if (schedDraft.mode === "hour") {
          return { ...s, [row.step_no]: { ...e, send_hour_utc: Math.min(23, Math.max(0, Number(schedDraft.hour) || 0)) } };
        }
        if (schedDraft.mode === "after") {
          const { days, minutes } = toDaysMinutes(schedDraft.qty, schedDraft.unit);
          return { ...s, [row.step_no]: { ...e, offset_days: days, delay_minutes: minutes, send_hour_utc: null } };
        }
        return { ...s, [row.step_no]: { ...e, offset_days: 0, delay_minutes: 0, send_hour_utc: null } };
      } else {
        if (schedDraft.mode === "after") {
          const { days, minutes } = toDaysMinutes(schedDraft.qty, schedDraft.unit);
          return { ...s, [row.step_no]: { ...e, offset_days: days, delay_minutes: minutes, send_hour_utc: null } };
        }
        return { ...s, [row.step_no]: { ...e, offset_days: 0, delay_minutes: 0, send_hour_utc: null } };
      }
    });

    setOpenSchedFor(null);
  };

  if (!campaignId) return null;

  // ---------- render ----------
  return (
    <div className="campaign-ui">
      <style>{sequenceBoardStyles}</style>

      <div className="psl-camp-card sb-card">
        <div className="sb-header">
          <h4>Steps</h4>
          <span className="sb-autostop" title="Recipients who reply are automatically removed from the campaign.">Auto-stops after a reply</span>
        </div>

        {loading ? (
          <div className="sb-loading">Loading…</div>
        ) : rows.length === 0 ? (
          <div className="sb-empty">
            <div className="sb-empty-inner">
              <div className="sb-dot" />
              <h5>No steps yet</h5>
              <p>Click <b>Add Step</b> to create your first message.</p>
            </div>
          </div>
        ) : (
          <div className="sb-steps">
            {rows.map((r, idx) => {
              const isOpen = openStep === r.step_no;
              const e = edits[r.step_no];

              const popover =
                openSchedFor === r.step_no
                  ? createPortal(
                    <div
                      className="psl-pop sb-pop"
                      ref={schedRef}
                      style={{
                        position: "fixed",
                        left: `${schedAnchor?.left ?? 0}px`,
                        top: `${schedAnchor?.top ?? 0}px`,
                        zIndex: 10000,
                        visibility: schedAnchor ? "visible" : "hidden",
                      }}
                    >
                      {idx === 0 ? (
                        <>
                          <label className="psl-radio">
                            <input
                              type="radio"
                              checked={schedDraft.mode === "immediate"}
                              onChange={() => setSchedDraft((d) => ({ ...d, mode: "immediate" }))}
                            />
                            <span>Send immediately after contact is added</span>
                          </label>

                          <div className="psl-pop-row">
                            <label className="psl-radio">
                              <input
                                type="radio"
                                checked={schedDraft.mode === "after"}
                                onChange={() => setSchedDraft((d) => ({ ...d, mode: "after" }))}
                              />
                              <span>Send after</span>
                            </label>
                            <input
                              className="psl-input"
                              type="number"
                              min={0}
                              value={schedDraft.qty}
                              onChange={(e) => setSchedDraft((d) => ({ ...d, qty: Number(e.target.value || 0) }))}
                              style={{ width: 90, marginLeft: 8 }}
                            />
                            <select
                              className="psl-input"
                              value={schedDraft.unit}
                              onChange={(e) => setSchedDraft((d) => ({ ...d, unit: e.target.value }))}
                              style={{ width: 150 }}
                            >
                              {["seconds", "minutes", "days", "weeks"].map((u) => (
                                <option key={u} value={u}>{u}</option>
                              ))}
                            </select>
                          </div>

                          <div className="psl-pop-row">
                            <label className="psl-radio">
                              <input
                                type="radio"
                                checked={schedDraft.mode === "hour"}
                                onChange={() => setSchedDraft((d) => ({ ...d, mode: "hour" }))}
                              />
                              <span>Send at hour</span>
                            </label>
                            <input
                              className="psl-input"
                              type="number"
                              min={0}
                              max={23}
                              value={schedDraft.hour}
                              onChange={(e) => setSchedDraft((d) => ({ ...d, hour: Number(e.target.value || 0) }))}
                              style={{ width: 80, marginLeft: 8 }}
                            />
                            <span>o'clock</span>
                            <button
                              className="sb-info"
                              style={{ marginLeft: 8 }}
                              onClick={() => setShowTimingHelp((v) => !v)}
                              aria-label="What does timing mean?"
                              title="About timing"
                            >
                              i
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <label className="psl-radio">
                            <input
                              type="radio"
                              checked={schedDraft.mode === "immediate"}
                              onChange={() => setSchedDraft((d) => ({ ...d, mode: "immediate" }))}
                            />
                            <span>Send immediately after previous step</span>
                          </label>

                          <div className="psl-pop-row">
                            <label className="psl-radio">
                              <input
                                type="radio"
                                checked={schedDraft.mode === "after"}
                                onChange={() => setSchedDraft((d) => ({ ...d, mode: "after" }))}
                              />
                              <span>Send after</span>
                            </label>
                            <input
                              className="psl-input"
                              type="number"
                              min={0}
                              value={schedDraft.qty}
                              onChange={(e) => setSchedDraft((d) => ({ ...d, qty: Number(e.target.value || 0) }))}
                              style={{ width: 90, marginLeft: 8 }}
                            />
                            <select
                              className="psl-input"
                              value={schedDraft.unit}
                              onChange={(e) => setSchedDraft((d) => ({ ...d, unit: e.target.value }))}
                              style={{ width: 150 }}
                            >
                              {["seconds", "minutes", "days", "weeks"].map((u) => (
                                <option key={u} value={u}>{u}</option>
                              ))}
                            </select>
                            <button
                              className="sb-info"
                              style={{ marginLeft: 8 }}
                              onClick={() => setShowTimingHelp((v) => !v)}
                              aria-label="What does timing mean?"
                              title="About timing"
                            >
                              i
                            </button>
                          </div>
                        </>
                      )}

                      {showTimingHelp && (
                        <div className="sb-help-pop">
                          <b>How timing works</b>
                          <ul>
                            <li><b>Immediately</b>: send right away.</li>
                            <li><b>After</b>: wait the amount you set before sending.</li>
                            <li><b>Send at hour (Step 1)</b>: schedule the first email at a specific hour.</li>
                          </ul>
                          <p>Campaigns automatically <b>stop after a recipient replies</b>.</p>
                        </div>
                      )}

                      <div className="psl-pop-actions">
                        <button className="psl-btn" onClick={() => setOpenSchedFor(null)}>
                          Cancel
                        </button>
                        <button
                          className="psl-btn primary"
                          data-tour="schedule-save"
                          onClick={() => applySchedule(r, idx)}
                        >
                          Save
                        </button>
                      </div>
                    </div>,
                    document.body
                  )
                  : null;
              const s1Subject =
                edits[1]?.subject ?? rows.find(x => x.step_no === 1)?.subject ?? "";


              return (
                <React.Fragment key={r.step_no}>
                  {/* row header */}
                  <div className={"psl-row sb-row " + (isOpen ? "is-selected" : "")}>
                    <div className="sb-left">
                      <button
                        className={"psl-row-toggle " + (isOpen ? "open" : "")}
                        onClick={() => toggleOpen(r.step_no)}
                        title={isOpen ? "Collapse" : "Expand"}
                        aria-label={isOpen ? "Collapse step" : "Expand step"}
                      />
                      <div className="sb-stepno">{r.step_no}</div>
                    </div>

                    <div className="sb-mid">
                      <div
                        className="sb-title"
                        onClick={() => toggleOpen(r.step_no)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(ev) => { if (ev.key === "Enter" || ev.key === " ") toggleOpen(r.step_no); }}
                        aria-label="Open inline editor"
                      >
                        <b>{titleFor(idx, r)}</b>
                      </div>
                      {/* Removed inline subject when collapsed to avoid confusion */}
                    </div>

                    <div className="sb-right">
                      <button
                        className="sb-when-link"
                        onClick={(ev) => openSchedule(r, idx, ev)}
                        title="Change when this step sends"
                        aria-haspopup="dialog"
                        aria-expanded={openSchedFor === r.step_no}
                      >
                        {sendLabel(idx)} ▾
                      </button>

                      {popover}

                      <div className="sb-row-actions">
                        <button className="psl-btn psl-btn--micro" title="Duplicate this step" onClick={() => duplicateRow(r)}>Duplicate</button>
                        <button className="psl-btn psl-btn--micro" title="Remove this step" onClick={() => removeRow(r)}>Remove</button>
                      </div>
                    </div>
                  </div>

                  {/* inline editor */}
                  {isOpen && (
                    <div className="psl-step-editor sb-editor">
                      {!e ? (
                        <div className="psl-camp-card sb-loading-card">Loading editor…</div>
                      ) : (
                        <div className="psl-inline-editor sb-inline">
                          <section className="psl-editor-pane sb-pane" style={{ gridColumn: "1 / -1" }}>
                            <div className="psl-editor-head sb-pane-head">
                              <b>Compose</b>
                              <div className="sb-pane-actions">
                                <button className="psl-btn" disabled={e.saving} onClick={() => saveInline(r.step_no)}>
                                  {e.saving ? "Saving…" : "Save"}
                                </button>
                                <button className="psl-btn" onClick={() => setOpenStep(null)}>Close</button>
                              </div>
                            </div>

                            <div className="psl-editor-body sb-pane-body">
                              {/* Subject */}
                              <label className="psl-fieldrow" style={{ justifyContent: "space-between" }}>
                                <div style={{ flex: 1 }}>
                                  <div className="psl-fieldlabel">Subject {r.step_no > 1 && <span className="psl-muted">(read-only, set at first step)</span>}</div>
                                  <input
                                    ref={subjectRef}
                                    className="psl-input"
                                    placeholder={r.step_no === 1 ? "Enter email subject" : "Set in Step 1"}
                                    value={r.step_no === 1 ? e.subject : s1Subject}
                                    readOnly={r.step_no > 1}
                                    onChange={(ev) => {
                                      if (r.step_no !== 1) return;
                                      setEdits((s) => ({ ...s, [r.step_no]: { ...s[r.step_no], subject: ev.target.value } }));
                                      setDraftDirty(true);
                                    }}
                                  />
                                </div>
                                {r.step_no > 1 && (
                                  <button
                                    type="button"
                                    className="sb-info"
                                    aria-label="Why can't I edit the subject?"
                                    title="Follow-ups reply in the original thread. Set the subject in Step 1."
                                    style={{ alignSelf: "end", marginLeft: 8 }}
                                  >
                                    i
                                  </button>
                                )}
                              </label>

                              {/* Body */}
                              <div>
                                <div className="psl-fieldlabel">Email body</div>
                                <textarea
                                  ref={bodyRef}
                                  className="psl-input sb-body"
                                  rows={14}
                                  placeholder="Write your message…"
                                  value={e.bodyText}
                                  onChange={(ev) => {
                                    setEdits((s) => ({ ...s, [r.step_no]: { ...s[r.step_no], bodyText: ev.target.value } }));
                                    setDraftDirty(true);
                                  }}
                                />
                              </div>

                              {/* tokens */}
                              <div className="psl-tokenbar sb-tokenbar">
                                <span className="sb-dynvars">
                                  Dynamic variables
                                  <button
                                    type="button"
                                    className="sb-info"
                                    aria-label="What are dynamic variables?"
                                    title="Dynamic variables personalize each message"
                                    onClick={() => setShowVarsHelp((v) => !v)}
                                  >
                                    i
                                  </button>
                                </span>
                                {TOKENS.map((t) => (
                                  <button key={t} className="psl-chip" onClick={() => insertToken("body", t)}>{t}</button>
                                ))}
                              </div>

                              {showVarsHelp && (
                                <div className="sb-help-pop">
                                  <b>Dynamic variables</b>
                                  <ul>
                                    <li><code>{"{{curator_name}}"}</code> — the recipient’s name</li>
                                    <li><code>{"{{playlist_name}}"}</code> — the playlist title</li>
                                    <li><code>{"{{playlist_url}}"}</code> — link to the playlist</li>
                                    <li><code>{"{{sender_name}}"}</code> — your name</li>
                                  </ul>
                                </div>
                              )}

                              {/* note: removed numeric mini-fields; timing is set via the popover above */}
                            </div>
                          </section>
                        </div>
                      )}
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        )}

        <div className="sb-actions">
          <button
            className="psl-btn"
            data-tour="add-step"
            onClick={addRow}
          >
            Add Step
          </button>
          <button className="psl-btn primary" data-tour="save-sequence" onClick={saveSequence}>
            Save Sequence
          </button>
        </div>


        {err && <div className="sb-error">{err}</div>}
      </div>

      {/* Sticky save bar */}
      <div className={"sb-sticky " + (dirty ? "is-visible" : "")} role="status" aria-live="polite">
        <div className="sb-sticky-inner">
          <span className="sb-sticky-badge">
            <span className="sb-sticky-dot" />
            Unsaved changes
          </span>
          <div className="sb-sticky-actions">
            <button className="psl-btn" onClick={discardChanges}>Discard</button>
            <button className="psl-btn primary" onClick={saveSequence}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SequenceBoard;
